export default function BrandLogo({
  className = '',
  homeLink = true,
}: {
  className?: string;
  homeLink?: boolean;
}) {
  return (
    <div className={`brand-lockup${className ? ` ${className}` : ''}`}>
      {homeLink && (
        <a className="brand-home" href="https://zemew.com/">
          Back to Zemew
        </a>
      )}
      <img
        className="brand-logo"
        src={`${import.meta.env.BASE_URL}zemew_theatre.png`}
        alt="Zemew Theatre"
      />
    </div>
  );
}
